export const KEY_FILTER_OPTIONS = {
  account: 'ACCOUNT',
  bank: 'BANK',
  client: 'CLIENT',
  legalRepresentative: 'LEGAL_REPRESENTATIVE',
  profile: 'PROFILE',
  status: 'STATUS',
  cveInternal: 'CVE_INTERNAL',
};

export const filterOptions = [
  { label: 'Cliente', value: KEY_FILTER_OPTIONS.client },
  { label: 'Instituci\u00F3n', value: KEY_FILTER_OPTIONS.bank },
  { label: 'Perfil', value: KEY_FILTER_OPTIONS.profile },
  { label: 'Asesor', value: KEY_FILTER_OPTIONS.legalRepresentative },
  { label: 'Estatus', value: KEY_FILTER_OPTIONS.status },
  { label: 'Cuenta', value: KEY_FILTER_OPTIONS.account },
  { label: 'Contrato', value: KEY_FILTER_OPTIONS.cveInternal },
];
